import { Outlet } from "react-router-dom";

const RootRoute = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default RootRoute;
